import { ButtonLink } from '@app/components/base/ButtonLink';
import { SocialPlatform } from '@app/modules/social-export/domain/platforms';
import { socialExport } from '@mi-front/api-clients';
import { Settings } from '@mui/icons-material';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PlatformDisconnect } from './PlatformDisconnect';
import { PlatformConnectFactory } from './platforms/PlatformConnectFactory';

interface Props {
  platform: SocialPlatform;
  stationId: string;
  state?: socialExport.GetConnectionStateDto;
}

export function FeatureActions({ platform, stationId, state }: Props) {
  if (!state?.connected) {
    return <PlatformConnectFactory platform={platform} stationId={stationId} />;
  }

  return (
    <Box display="flex" gap={2} mt={2}>
      <ButtonLink
        variant="outlined"
        color="info"
        size="small"
        to={`/admin/social-export/${platform.id.toLowerCase()}/settings/${stationId}`}
        startIcon={<Settings />}
      >
        <FormattedMessage id="socialExport.manage.configure" defaultMessage="Configurar" />
      </ButtonLink>
      <PlatformDisconnect platform={platform} stationId={state.stationId} />
    </Box>
  );
}
